import { Typography } from 'components/ui';

const Ratio = ({ complianceRatio = 1 }) => {
  if (complianceRatio == null) return null;

  const color =
    complianceRatio >= 0.75
      ? 'success'
      : complianceRatio >= 0.5
        ? 'warning'
        : complianceRatio > 0
          ? 'textSecondary'
          : 'error';
  const percent = Math.round(complianceRatio * 100);

  return (
    <Typography component="span" color={color}>
      {percent}%
    </Typography>
  );
};

export default Ratio;
